import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sendInvites", "sendDate"]

  connect() {
    this.toggleSendDate()
  }

  toggleSendDate() {
    if (!this.hasSendInvitesTarget || !this.hasSendDateTarget) return

    const show = this.sendInvitesTarget.checked
    this.sendDateTarget.hidden = !show
    this.sendDateTarget.classList.toggle("hidden", !show)
  }
}
